<template>
	<div class="dashboard">
		<top-header></top-header>
		<p class="text-center mt-3">Welcome to DYO Admin Dashboard</p>
		<b-container fluid>
			<b-row>
				<b-col>
					<b-card img-src="../assets/icons/crm.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Users</h6>
						<b-card-text>
							{{total_users}} Nos
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-link href="/dyo/products">
						<b-card img-src="../assets/icons/t-shirt.svg" img-alt="Card image" img-left class="info-box mb-3">
							<h6>Total Products</h6>
							<b-card-text>
								{{total_products}} Nos
							</b-card-text>
						</b-card>
					</b-link>
				</b-col>
				<!--<b-col>
					<b-card img-src="../assets/dcu-connection.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Connected DCU</h6>
						<b-card-text>
							{{total_device_on}}
						</b-card-text>
					</b-card>
				</b-col>-->
				<b-col>
					<b-card img-src="" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Power Cut</h6>
						<b-card-text>0
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Temporary Signal Loss</h6>
						<b-card-text>0
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<top-footer></top-footer>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
		"top-header": Header
	},
	mounted(){
		this.initload();
	},
	data() {
		return{
			total_users: 0,
			total_products: 0,
			url: this.$root.WEBAPI+'dashboard'
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.total_users = response.data.result.total_users;
					self.total_products = response.data.result.total_products;
					/*

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;*/

				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>